import { render, staticRenderFns } from "./AutomationsSettings.vue?vue&type=template&id=2330701e"
import script from "./AutomationsSettings.vue?vue&type=script&lang=js"
export * from "./AutomationsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports